// Program and conference prestige (college). A team's prestige runs 1-5; a
// conference's is the average of its teams'. Public information: managers
// see both as stars. Pure.

/** Prestige for a team with none (an uploaded league without the column). */
export const DEFAULT_PRESTIGE = 3;

/**
 * Each conference's prestige: the average of its teams'.
 * @param {object[]} teams team documents or summary rows ({conference,
 *   prestige})
 * @return {object} {conferenceId: average prestige}
 */
export function conferencePrestige(teams) {
  const sums = {};
  for (const t of teams) {
    if (!t?.conference) continue;
    const s = sums[t.conference] ?? (sums[t.conference] = {total: 0, n: 0});
    s.total += t.prestige ?? DEFAULT_PRESTIGE;
    s.n++;
  }
  return Object.fromEntries(Object.entries(sums).map(([id, s]) =>
    [id, s.total / s.n]));
}

/**
 * Prestige rounded to the nearest half star, for display.
 * @param {number} value 1-5
 * @return {number} 1, 1.5, ... 5
 */
export function prestigeStars(value) {
  return Math.min(5, Math.max(1, Math.round((value ?? DEFAULT_PRESTIGE) * 2) /
    2));
}
